import useSWR from "swr";
import { RefreshButton } from "@/components/list/refresh-button";
import { ListEmpty, ListLoading } from "@/components/list/status-text";
import { Section } from "@/components/section";
import { fetcher } from "@/lib/swr";
import type { Subscription } from "@/components/webhooks/webhook-events";
import { WebhookDialog } from "@/components/webhooks/webhook-dialog";
import { SubscriptionRow } from "@/components/webhooks/subscription-row";

// App Settings → Webhooks: subscriptions bound to this app (pid is pinned
// server-side). Owner or admin — parent gates rendering, the server
// re-checks on every endpoint.
export const AppWebhooksSection = ({ pid }: { pid: string }) => {
  const apiBase = `/apps/${pid}/webhooks`;
  const {
    data: subs,
    isLoading,
    isValidating,
    mutate: refresh,
  } = useSWR<Subscription[]>([apiBase], fetcher);
  const list = subs ?? [];

  return (
    <Section
      title="Webhooks"
      action={
        <div className="flex items-center gap-2">
          <RefreshButton spinning={isValidating} onClick={() => refresh()} />
          <WebhookDialog
            onSaved={() => refresh()}
            apiBase={apiBase}
            fixedPid={pid}
          />
        </div>
      }
    >
      <p className="text-xs text-muted-foreground">
        本 app 事件的对外回调订阅(HMAC-SHA256 签名,fire-and-forget 不重试);
        payload 与验签见 server/docs/webhooks.md。
      </p>
      <div className="flex flex-col gap-1">
        {isLoading && <ListLoading />}
        {!isLoading && list.length === 0 && (
          <ListEmpty>No webhook subscriptions.</ListEmpty>
        )}
        {list.map((sub, i) => (
          <SubscriptionRow
            key={sub.id}
            sub={sub}
            index={i}
            onChanged={() => refresh()}
            apiBase={apiBase}
            fixedPid={pid}
          />
        ))}
      </div>
    </Section>
  );
};
